export function ContactFooter() {
  return (
    <footer className="bg-gray-800 text-white py-6 mt-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-2">Kontakt & Saradnja</h3>
            <p className="text-gray-300 text-sm">
              Imate ideju, predlog ili želite da pomognete u razvoju?
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-6">
            <a
              href="mailto:rajko@danposle.org"
              className="flex items-center space-x-2 text-blue-300 hover:text-blue-200 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span>rajko@danposle.org</span>
            </a>
            
            <a
              href="https://x.com/rajko_alt"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-blue-300 hover:text-blue-200 transition-colors"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              <span>@rajko_alt</span>
            </a>
          </div>
        </div>
        
        <div className="mt-4 pt-4 border-t border-gray-700 text-center text-gray-400 text-sm">
          <p>Širimo se - Real-time monitoring za društvene pokrete</p>
        </div>
      </div>
    </footer>
  )
} 